import { lazy, Suspense, useEffect, useState } from 'react'
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom'
import { useMainContext } from '../core/contexts/main'
import i18next from 'i18next'
import UserInvite from './UserInvite'
import GlobalLoading from '../components/layouts/loading/GlobalLoading'
import BankCallback from './BankCallback'
import CrispProvider from '../components/layouts/crisp/components/CrispProvider'
import TransactionHistoryPage from './TransactionHistoryPage'
import UserOtc from './UserOtc'
import { SocketProvider } from '../core/contexts/socket'
import { SocketContentProvider } from '../core/contexts/socket-content'
import { TradePriceProvider } from '../core/contexts/trade-price'
import TransfersHistoryPage from './TransfersHistoryPage'
import RStaking from '../modules/staking/components/RStaking'
import RStakingHistory from '../modules/staking/components/RStakingHistory'
import Transactions from './transactions'
import AuthPage from './auth/Auth'
import UserSwap from './swap'
// import RegisterPage from './RegisterPage'

const UserCurrentOrders = lazy(() => import('./UserCurrentOrders'))
// const RegisterSignIn = lazy(() => import('./RegisterSignIn'))
const UserOrdersHistory = lazy(() => import('./UserOrdersHistory'))
const UserOtcHistory = lazy(() => import('./UserOtcHistory'))
const UserAccountsAndCards = lazy(() => import('./accounts/NewUserAccounts'))
const UserTickets = lazy(() => import('./UserTickets'))
// const UserNotifications = lazy(() => import('./UserNotifications'))
const UserNotifications = lazy(() => import('./NewUserNotifications'))
const UserWallets = lazy(() => import('./NewUserWallet'))
const UserWalletsOperation = lazy(() => import('./UserWalletsOperation'))
const UserAuthentication = lazy(() => import('./UserAuthentication'))
const UserSecurity = lazy(() => import('./UserSecurity'))
const MainUserDashboard = lazy(() => import('./NewMainDashboard'))
const UserProfile = lazy(() => import('./UserProfile'))
const WalletCharts = lazy(() => import('./WalletCharts'))
const UserTrace = lazy(() => import('./UserTrace'))
const Trade = lazy(() => import('./trade/main/Trade'))
const AdvanceTrade = lazy(() => import('./trade/main/AdvanceTrade'))
const StakingMain = lazy(() => import('../modules/staking/index'))

const TempWallet = lazy(() => import('./wallet/NewUserWallet'))

const Index = () => {
	const {
		main: { lang, theme },
		profile: { token },
	} = useMainContext()

	useEffect(() => {
		i18next.changeLanguage(lang)
		//eslint-disable-next-line
	}, [])

	useEffect(() => {
		if (theme === 'dark') {
			document.documentElement.classList.add('dark')
		} else {
			document.documentElement.classList.remove('dark')
		}
	}, [theme])

	return (
		<Router basename={process.env.PUBLIC_URL}>
			<Suspense fallback={<GlobalLoading />}>
				<CrispProvider>
					<SocketProvider>
						<SocketContentProvider>
							<TradePriceProvider>
								{token ? (
									<Routes>
										<Route index path='/dashboard' element={<MainUserDashboard />} />

										{routes.map((route) => (
											<Route path={route.path} element={route.element} />
										))}

										<Route path='*' element={<Navigate to='/dashboard' replace />} />
									</Routes>
								) : (
									<Routes>
										<Route path='/auth/*' element={<AuthPage />} />

										<Route path='/auth/signup' element={<AuthPage />} />
										<Route path='/auth/signup/otp' element={<AuthPage />} />
										<Route path='/auth/signin' element={<AuthPage />} />
										<Route path='/auth/signin/otp' element={<AuthPage />} />
										<Route path='/auth/forget-password' element={<AuthPage />} />

										<Route path='*' element={<Navigate to='/auth/signin' replace />} />
									</Routes>
								)}
							</TradePriceProvider>
						</SocketContentProvider>
					</SocketProvider>
				</CrispProvider>
			</Suspense>
		</Router>
	)
}

const routes = [
	{ path: '/current-orders', element: <UserCurrentOrders /> },
	{ path: '/orders-history', element: <UserOrdersHistory /> },
	{ path: '/otc-history', element: <UserOtcHistory /> },
	{ path: '/otc', element: <UserOtc /> },
	// { path: '/swap', element: <UserSwap /> },
	// { path: '/transaction-history', element: <UserTransactionHistory /> },
	{ path: '/accounts-cards', element: <UserAccountsAndCards /> },
	{ path: '/tickets', element: <UserTickets /> },
	// { path: '/notifications', element: <UserNotifications /> },
	{ path: '/notifications', element: <UserNotifications /> },
	{ path: '/notifications/:subpage', element: <UserNotifications /> },
	{ path: '/wallets_old', element: <TempWallet /> },
	{ path: '/wallets', element: <UserWallets /> },
	{ path: '/wallets/:subpage', element: <UserWallets /> },
	{ path: '/transactions', element: <Transactions /> },
	{ path: '/transactions/:subpage', element: <Transactions /> },
	{ path: '/transfers-history', element: <TransfersHistoryPage /> },
	{ path: '/wallet-operations', element: <UserWalletsOperation /> },
	{ path: '/authentication', element: <UserAuthentication /> },
	{ path: '/security', element: <UserSecurity /> },
	{ path: '/profile', element: <UserProfile /> },
	{ path: '/profile/:subpage', element: <UserProfile /> },
	{ path: '/invite', element: <UserInvite /> },
	{ path: '/callback', element: <BankCallback /> },
	{ path: '/wallet-charts', element: <WalletCharts /> },
	{ path: '/log', element: <UserTrace /> },
	// { path: '/trade', element: <Trade /> },
	// { path: '/trade/advance', element: <AdvanceTrade /> },
	// { path: '/staking', element: <StakingMain /> },
	// { path: '/staking-history', element: <StakingMain /> },
	// { path: '/rstaking', element: <RStaking /> },
	// { path: '/rstaking-history', element: <RStakingHistory /> },
]

export default Index
